import { deburr } from 'lodash'
import React from 'react'
import { FormattedMessage } from 'react-intl'

// remember to define the initial values below after adding a new field and to the validation schema in utils
export const FORM_FIELDS = {
  USERNAME_FORMAT: 'usernameFormat',
  DOMAIN: 'domain',
  COUNTRY: 'country',
  LICENSES: 'licenses',
  DISPLAY_PURCHASE_LINK: 'displayPurchaseLink',
  PURCHASE_LINK: 'purchaseLink',
  IS_AUTO_GENERATING_PASSWORD: 'isAutoGeneratingPassword',
  CHANGE_PASSWORD_AT_NEXT_LOGIN: 'changePasswordAtNextLogin',
  SEND_PASSWORD_ON_COMPLETION: 'sendPasswordOnCompletion',
  GROUPS: 'groups',
  SECURITY_GROUPS: 'securityGroups',
  ENABLE_POWERSHELL_ACCESS: 'enablePowershellAccess',
}

export const INITIAL_VALUES = {
  [FORM_FIELDS.USERNAME_FORMAT]: null,
  [FORM_FIELDS.DOMAIN]: null,
  [FORM_FIELDS.COUNTRY]: null,
  [FORM_FIELDS.LICENSES]: [],
  [FORM_FIELDS.DISPLAY_PURCHASE_LINK]: false,
  [FORM_FIELDS.PURCHASE_LINK]: '',
  [FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD]: true,
  [FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN]: true,
  [FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]: true,
  [FORM_FIELDS.GROUPS]: [],
  [FORM_FIELDS.SECURITY_GROUPS]: [],
  [FORM_FIELDS.ENABLE_POWERSHELL_ACCESS]: false,
}

export const CREATE_USER_PANEL_FIELDS = {
  [FORM_FIELDS.USERNAME_FORMAT]: true,
  [FORM_FIELDS.DOMAIN]: true,
  [FORM_FIELDS.COUNTRY]: true,
  [FORM_FIELDS.LICENSES]: true,
  [FORM_FIELDS.DISPLAY_PURCHASE_LINK]: true,
  [FORM_FIELDS.PURCHASE_LINK]: true,
  [FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD]: true,
  [FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN]: true,
  [FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]: true,
}

export const STEP_KEYS = {
  CREATE_USER: 'CREATE_USER',
  OPTIONAL_SETTINGS: 'OPTIONAL_SETTINGS',
  SUBMIT: 'SUBMIT',
}

export const MODAL_STEPS = [
  {
    label: <FormattedMessage id="ENGAGE.ONBOARD.CREATE_USER" />,
    key: STEP_KEYS.CREATE_USER,
  },
  {
    label: <FormattedMessage id="GENERAL.OPTIONAL_SETTINGS" />,
    key: STEP_KEYS.OPTIONAL_SETTINGS,
  },
  {
    label: null,
    key: STEP_KEYS.SUBMIT,
  },
]

// so far all optional settings are tenant specific
export const GLOBAL_MODAL_STEPS = [
  {
    label: null,
    key: STEP_KEYS.CREATE_USER,
  },
  {
    label: null,
    key: STEP_KEYS.SUBMIT,
  },
]

const toUsername = (str) =>
  deburr(String(str ?? ''))
    .trim()
    .replaceAll(' ', '_')
    .toLowerCase()

export const USERNAME_FORMAT_OPTIONS = [
  { label: 'firstname', value: 'firstname', format: ({ firstName }) => toUsername(firstName) },
  {
    label: 'first.last',
    value: 'first.last',
    format: ({ firstName, lastName }) => `${toUsername(firstName)}.${toUsername(lastName)}`,
  },
  {
    label: 'f.last',
    value: 'f.last',
    format: ({ firstName, lastName }) => `${toUsername(firstName).charAt(0)}.${toUsername(lastName)}`,
  },
  {
    label: 'flast',
    value: 'flast',
    format: ({ firstName, lastName }) => `${toUsername(firstName).charAt(0)}${toUsername(lastName)}`,
  },
  {
    label: 'first.l',
    value: 'first.l',
    format: ({ firstName, lastName }) => `${toUsername(firstName)}.${toUsername(lastName).charAt(0)}`,
  },
  {
    label: 'firstl',
    value: 'firstl',
    format: ({ firstName, lastName }) => `${toUsername(firstName)}${toUsername(lastName).charAt(0)}`,
  },
  {
    label: 'firstlast',
    value: 'firstlast',
    format: ({ firstName, lastName }) => `${toUsername(firstName)}${toUsername(lastName)}`,
  },
  { label: 'lastname', value: 'lastname', format: ({ lastName }) => toUsername(lastName) },
  {
    label: 'last.f',
    value: 'last.f',
    format: ({ firstName, lastName }) => `${toUsername(lastName)}.${toUsername(firstName).charAt(0)}`,
  },
  {
    label: 'lastf',
    value: 'lastf',
    format: ({ firstName, lastName }) => `${toUsername(lastName)}${toUsername(firstName).charAt(0)}`,
  },
]

export const USERNAME_FORMAT_TO_FUNC = USERNAME_FORMAT_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.format
  return acc
}, {})
